import Vue from 'vue'
import { Notify } from 'vant'

// 校验数据是否不为空且是否符合规则
// 校验顺序为form的遍历顺序，遇到第一个校验失败的时候会终止校验。
Vue.prototype.$validate = function (form, rules, showMsg1) {
  return new Promise((resolve, reject) => {
    var showMsg = showMsg1
    if (typeof showMsg1 === 'undefined') { showMsg = true }
    for (var i in form) {
      if (rules[i]) {
        var rule = rules[i]
        var data = form[i]
        for (var j in rule) {
          if (!rule[j].regex || rule[j].regex === '') {
            if (!data || data === '') {
              if (showMsg) {
                Notify({ message: rule[j].msg, type: 'danger', duration: 5 * 1000 })
              }
              reject()
              return
            }
          } else {
            if (typeof rule[j].regex === 'object') {
              if (rule[j].regex.test && !rule[j].regex.test(data)) {
                if (showMsg) {
                  Notify({ message: rule[j].msg, type: 'danger', duration: 5 * 1000 })
                }
                reject()
                return
              }
            } else if (!new RegExp(rule[j].regex).test(data)) {
              if (showMsg) {
                Notify({ message: rule[j].msg, type: 'danger', duration: 5 * 1000 })
              }
              reject()
              return
            }
          }
        }
      }
    }
    resolve(true)
  })
}

// 校验数据是否不为空且是否符合规则
// 校验顺序为form的遍历顺序，遇到第一个校验失败的时候会终止校验。
Vue.prototype.$validateI18n = function (form, rules, showMsg1) {
  return new Promise((resolve, reject) => {
    var showMsg = showMsg1
    if (typeof showMsg1 === 'undefined') { showMsg = true }
    for (var i in form) {
      if (rules[i]) {
        var rule = rules[i]
        var data = form[i]
        for (var j in rule) {
          if (!rule[j].regex || rule[j].regex === '') {
            if (!data || data === '') {
              if (showMsg) {
                Notify({ message: Vue.prototype.$t3(...rule[j].msg), type: 'danger', duration: 5 * 1000 })
              }
              reject()
              return
            }
          } else {
            if (rule[j].canNull && !data) {
              continue;
            } else {
              if (!new RegExp(rule[j].regex).test(data)) {
                if (showMsg) {
                  Notify({ message: Vue.prototype.$t3(...rule[j].msg), type: 'danger', duration: 5 * 1000 })
                }
                reject()
                return
              }
            }
          }
        }
      }
    }
    resolve(true)
  })
}

Vue.prototype.$checkTimeBetween = function (start, end) {
  if (!start || !end) {
    return false
  }
  const now = new Date()
  const startDate = new Date(start.replace(/-/g, '/'))
  const endDate = new Date(end.replace(/-/g, '/'))
  if (now >= startDate && now <= endDate) {
    return true
  }
  return false
}
